module.exports = "/build/web/svg/article-type-video.64c995ecc9797731795f41eacf626041.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/article-type-video.svg
// module id = 146
// module chunks = 24